module.exports = __webpack_public_path__ + "static/img/logo.91b936e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.webp
// module id = o7zP
// module chunks = 0